import React, { Component } from "react";

export default class QuestionEdit extends Component {

  constructor(props) {
    super(props);
    this.state = {question: '', category: '', category_vs: '', active: false, categories: []};


    // Fast redirection?
    if(!this.state.user || this.state.user.role != 'admin')
      window.location.replace('/login');
    // Bindings
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    this.questionGet();
  }

  onChange = (e) => {
    const state = this.state;
    state[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    this.setState(state);
  }

  onSubmit(event) {
    event.preventDefault();
    var qId = this.props.match.params.id;
    const formData = this.state;
    fetch(process.env.REACT_APP_API_URL + '/questions/' + qId + '/update', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then((response) => {
      return response.json();
    })
    .then((data) => {
      console.log('data', data);
      if( data._id ) alert('Updated!');
    });
  }

  questionGet() {
    var qId = this.props.match.params.id;
    fetch(process.env.REACT_APP_API_URL + '/questions/' + qId)
      .then( ( response ) => response.json() )
      .then( ( data ) => {

        fetch(process.env.REACT_APP_API_URL + '/categories')
          .then( ( response ) => response.json() )
          .then( ( categories ) => {
            this.setState({
              question: data.question,
              category: data.category,
              category_vs: data.category_vs,
              active: data.active,
              categories: categories
            });
          });

      });
  }

  render() {

    const catOptions = this.state.categories.map((item, i) => (
        <option key={i} value={item._id}>
          { item.name }
        </option>
    ));

    return (
      <form id="new-form" className="form container" method="POST" onSubmit={ this.onSubmit }>
        <div className="form-group">
          <label>Pregunta</label>
          <input name="question" className="form-control form-control-lg" value={this.state.question} onChange={ this.onChange } />
        </div>
        <div className="form-group">
          <label>Categor&iacute;a</label>
          <select name="category" className="form-control form-control-lg" value={this.state.category} onChange={ this.onChange }>
            <option value="">Seleccione</option>
            { catOptions }
          </select>
        </div>
        <div className="form-group">
          <label>Categor&iacute;a Versus</label>
          <select name="category_vs" className="form-control form-control-lg" value={this.state.category_vs} onChange={ this.onChange }>
            <option value="">Seleccione</option>
            { catOptions }
          </select>
        </div>
        <div className="form-group">
          <div className="form-check">
            <label className="form-check-label">
              <input name="active" className="form-check-input" type="checkbox" checked={this.state.active} onChange={ this.onChange } />
              Activa
            </label>
          </div>
        </div>
        <input type="submit" className="btn btn-primary" value="Update" />
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/QuestionEdit.jsx